
export const lvcPath = [[new google.maps.LatLng(51.347693, 5.000383),
  new google.maps.LatLng(51.968738, 5.001756),
  new google.maps.LatLng(51.971276, 6.723177),
  new google.maps.LatLng(51.349409, 6.728670),
  new google.maps.LatLng(51.347693, 5.000383)],
  [new google.maps.LatLng(51.678091, 5.734091),
  new google.maps.LatLng(51.662015, 5.738425),
  new google.maps.LatLng(51.662041, 5.739369),
  new google.maps.LatLng(51.593975, 5.759068),
  new google.maps.LatLng(51.598294, 5.786490),
  new google.maps.LatLng(51.593575, 5.789334),
  new google.maps.LatLng(51.578643, 5.800331),
  new google.maps.LatLng(51.568774, 5.820683),
  new google.maps.LatLng(51.566080, 5.839148),
  new google.maps.LatLng(51.560638, 5.890732),
  new google.maps.LatLng(51.552010, 5.907225),
  new google.maps.LatLng(51.553459, 5.931629),
  new google.maps.LatLng(51.553495, 5.935262),
  new google.maps.LatLng(51.561603, 5.976421),
  new google.maps.LatLng(51.570191, 6.003976),
  new google.maps.LatLng(51.563221, 6.018181),
  new google.maps.LatLng(51.557855, 6.025027),
  new google.maps.LatLng(51.552168, 6.031786),
  new google.maps.LatLng(51.553788, 6.032474),
  new google.maps.LatLng(51.554091, 6.033719),
  new google.maps.LatLng(51.554590, 6.033483),
  new google.maps.LatLng(51.555159, 6.033751),
  new google.maps.LatLng(51.556912, 6.032641),
  new google.maps.LatLng(51.557014, 6.033717),
  new google.maps.LatLng(51.557465, 6.034340),
  new google.maps.LatLng(51.557584, 6.035510),
  new google.maps.LatLng(51.558097, 6.037340),
  new google.maps.LatLng(51.556753, 6.039757),
  new google.maps.LatLng(51.556614, 6.041137),
  new google.maps.LatLng(51.556794, 6.042731),
  new google.maps.LatLng(51.557401, 6.044496),
  new google.maps.LatLng(51.558614, 6.043048),
  new google.maps.LatLng(51.558960, 6.044531),
  new google.maps.LatLng(51.557810, 6.046379),
  new google.maps.LatLng(51.558501, 6.047713),
  new google.maps.LatLng(51.559310, 6.046368),
  new google.maps.LatLng(51.561609, 6.043249),
  new google.maps.LatLng(51.564548, 6.040302),
  new google.maps.LatLng(51.569037, 6.037968),
  new google.maps.LatLng(51.571788, 6.037509),
  new google.maps.LatLng(51.574380, 6.037566),
  new google.maps.LatLng(51.578308, 6.038944),
  new google.maps.LatLng(51.581276, 6.039679),
  new google.maps.LatLng(51.585016, 6.038182),
  new google.maps.LatLng(51.587260, 6.036446),
  new google.maps.LatLng(51.591930, 6.030333),
  new google.maps.LatLng(51.594640, 6.026663),
  new google.maps.LatLng(51.600708, 6.024023),
  new google.maps.LatLng(51.602742, 6.023806),
  new google.maps.LatLng(51.609062, 6.024170),
  new google.maps.LatLng(51.615542, 6.023933),
  new google.maps.LatLng(51.618062, 6.023199),
  new google.maps.LatLng(51.620227, 6.021673),
  new google.maps.LatLng(51.622952, 6.018646),
  new google.maps.LatLng(51.629496, 6.008059),
  new google.maps.LatLng(51.632661, 6.003194),
  new google.maps.LatLng(51.635693, 5.998244),
  new google.maps.LatLng(51.636459, 5.996167),
  new google.maps.LatLng(51.637507, 5.994829),
  new google.maps.LatLng(51.641787, 5.983688),
  new google.maps.LatLng(51.645711, 5.972453),
  new google.maps.LatLng(51.647238, 5.969715),
  new google.maps.LatLng(51.650447, 5.966334),
  new google.maps.LatLng(51.652024, 5.965158),
  new google.maps.LatLng(51.656610, 5.963597),
  new google.maps.LatLng(51.660830, 5.963165),
  new google.maps.LatLng(51.673720, 5.964746),
  new google.maps.LatLng(51.682268, 5.963409),
  new google.maps.LatLng(51.696967, 5.957433),
  new google.maps.LatLng(51.700644, 5.956119),
  new google.maps.LatLng(51.707509, 5.956277),
  new google.maps.LatLng(51.709665, 5.955112),
  new google.maps.LatLng(51.711023, 5.953431),
  new google.maps.LatLng(51.713310, 5.947788),
  new google.maps.LatLng(51.715889, 5.937370),
  new google.maps.LatLng(51.717311, 5.925252),
  new google.maps.LatLng(51.717883, 5.913305),
  new google.maps.LatLng(51.719000, 5.903649),
  new google.maps.LatLng(51.720967, 5.896611),
  new google.maps.LatLng(51.723439, 5.890968),
  new google.maps.LatLng(51.725048, 5.888189),
  new google.maps.LatLng(51.727666, 5.885582),
  new google.maps.LatLng(51.731534, 5.884445),
  new google.maps.LatLng(51.736763, 5.884134),
  new google.maps.LatLng(51.742380, 5.881360),
  new google.maps.LatLng(51.747997, 5.879960),
  new google.maps.LatLng(51.750640, 5.878351),
  new google.maps.LatLng(51.753157, 5.874885),
  new google.maps.LatLng(51.755054, 5.871479),
  new google.maps.LatLng(51.756631, 5.867729),
  new google.maps.LatLng(51.758570, 5.859962),
  new google.maps.LatLng(51.759287, 5.852966),
  new google.maps.LatLng(51.759340, 5.848589),
  new google.maps.LatLng(51.758065, 5.834427),
  new google.maps.LatLng(51.757215, 5.817862),
  new google.maps.LatLng(51.755648, 5.800910),
  new google.maps.LatLng(51.753695, 5.791447),
  new google.maps.LatLng(51.752194, 5.781169),
  new google.maps.LatLng(51.752101, 5.774066),
  new google.maps.LatLng(51.752852, 5.764636),
  new google.maps.LatLng(51.753998, 5.759191),
  new google.maps.LatLng(51.755117, 5.754347),
  new google.maps.LatLng(51.756671, 5.749884),
  new google.maps.LatLng(51.758384, 5.746322),
  new google.maps.LatLng(51.760456, 5.743382),
  new google.maps.LatLng(51.764786, 5.739316),
  new google.maps.LatLng(51.769433, 5.735421),
  new google.maps.LatLng(51.771545, 5.732760),
  new google.maps.LatLng(51.773291, 5.728812),
  new google.maps.LatLng(51.774187, 5.725207),
  new google.maps.LatLng(51.774871, 5.721248),
  new google.maps.LatLng(51.774917, 5.711067),
  new google.maps.LatLng(51.771868, 5.707599),
  new google.maps.LatLng(51.769696, 5.702586),
  new google.maps.LatLng(51.768404, 5.700585),
  new google.maps.LatLng(51.761376, 5.696052),
  new google.maps.LatLng(51.759075, 5.690660),
  new google.maps.LatLng(51.755668, 5.693568),
  new google.maps.LatLng(51.755186, 5.699871),
  new google.maps.LatLng(51.755783, 5.702036),
  new google.maps.LatLng(51.750196, 5.700328),
  new google.maps.LatLng(51.750139, 5.703552),
  new google.maps.LatLng(51.742379, 5.701344),
  new google.maps.LatLng(51.742125, 5.699790),
  new google.maps.LatLng(51.738364, 5.698192),
  new google.maps.LatLng(51.736550, 5.707794),
  new google.maps.LatLng(51.732188, 5.706158),
  new google.maps.LatLng(51.731482, 5.710361),
  new google.maps.LatLng(51.732644, 5.718578),
  new google.maps.LatLng(51.730647, 5.718395),
  new google.maps.LatLng(51.729183, 5.712617),
  new google.maps.LatLng(51.729115, 5.710655),
  new google.maps.LatLng(51.728302, 5.709680),
  new google.maps.LatLng(51.727661, 5.711720),
  new google.maps.LatLng(51.726325, 5.713355),
  new google.maps.LatLng(51.725959, 5.709282),
  new google.maps.LatLng(51.723357, 5.707674),
  new google.maps.LatLng(51.722428, 5.705519),
  new google.maps.LatLng(51.711422, 5.699887),
  new google.maps.LatLng(51.678091, 5.734091)]]
